// redux/teacherReviews/operations.js
import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import axiosStudentInstance from "../../axiosStudentInstance.js";

// 📥 1. GET — получить все отзывы преподавателя
export const fetchTeacherReviews = createAsyncThunk(
  "teacherReviews/fetchAll",
  async (teacherId, { rejectWithValue }) => {
    try {
      const { data } = await axiosStudentInstance.get(
        `/reviews/teacher/${teacherId}/reviews`
      );
      // console.log("Показ всех!");

      return data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch reviews"
      );
    }
  }
);

// 📤 2. POST — создать отзыв
export const createTeacherReview = createAsyncThunk(
  "teacherReviews/create",
  async ({ teacherId, data }, { rejectWithValue }) => {
    try {
      const response = await axiosStudentInstance.post(
        `/reviews/teacher/${teacherId}/review`,
        data
      );
      // console.log("Создаём!");

      // toast.success("Review submitted");

      return response.data; // ✅ вернёт полный отзыв с id, name, avatar и т.д.
    } catch (err) {
      // console.log(err);

      // toast.error(err.response?.data?.message || "Failed to submit review");
      return rejectWithValue(err.response?.data?.message);
    }
  }
);
// ✏️ 3. PATCH — обновить отзыв
export const updateTeacherReview = createAsyncThunk(
  "teacherReviews/update",
  async ({ teacherId, data }, { rejectWithValue }) => {
    try {
      const response = await axiosStudentInstance.patch(
        `/reviews/teacher/${teacherId}/review`,
        data
      );

      // toast.success("Review updated");
      // console.log("Обновляем!!", response.data);

      return response.data; // ✅ возвращаем весь отзыв
    } catch (err) {
      // toast.error(err.response?.data?.message || "Failed to update review");
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

// ❌ 4. DELETE — удалить отзыв
export const deleteTeacherReview = createAsyncThunk(
  "teacherReviews/delete",
  async (teacherId, { rejectWithValue }) => {
    try {
      const response = await axiosStudentInstance.delete(
        `/reviews/teacher/${teacherId}/review`
      );

      // toast.success("Review deleted");
      return response.data; // ✅ теперь возвращается { id, student_id, ... }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to delete review");
      return rejectWithValue(err.response?.data?.message);
    }
  }
);
